import { inject, Injectable } from "@angular/core";
import { Location } from "@angular/common";
import { ActivatedRoute } from "@angular/router";
import { Menu, MenuContent, MenuContentItem, MenuKeys } from "@models/interfaces/components/Menu.interface";
import { findMenuContentById } from "./menu-content-tree.util";

@Injectable()
export class MenuParamsService {

    // SERVICES
    private readonly location:       Location          = inject(Location);
    private readonly route:          ActivatedRoute    = inject(ActivatedRoute);

    // PUBLIC METHODS

    /**
     * Método que actualiza los parámetros del menú en la URL.
     * @param selectedMenu - Clave del menú seleccionado (o null).
     * @param selectedItem - Elemento del menú seleccionado (o null).
     * @param menu - Menú seleccionado contra el que se valida el item.
     */
    public updateMenuParams(selectedMenu: MenuKeys | null, selectedItem: MenuContentItem | null, menu?: Menu): void {

        const currentParams: URLSearchParams = new URLSearchParams(window.location.search);

        // check initially — if nothing selected, clear both and return
        if (!selectedMenu || !selectedItem) {
            currentParams.delete('menu_id');
            currentParams.delete('menu_item_id');
            this.location.replaceState(window.location.pathname, currentParams.toString());
            return;
        }

        if (!menu) return;

        // Try to match by id
        const matchedItem: MenuContent | undefined = findMenuContentById(menu.content, selectedItem.id);

        // Only add params if valid combo (type matches or found in menu)
        if (selectedItem.type === selectedMenu || matchedItem) {

            currentParams.set('menu_id', selectedMenu);
            currentParams.set('menu_item_id', String(selectedItem.id));

        } else {

            currentParams.delete('menu_id');
            currentParams.delete('menu_item_id');

        }

        this.location.replaceState(window.location.pathname, currentParams.toString());

    }

    /**
     * Lee de la URL la seleccion inicial de menu usada al montar el minisite.
     *
     * @returns Identificadores `menu_id` y `menu_item_id` presentes en los query params.
     */
    public getInitialSelectionParams(): { menuId: string | null; menuItemId: string | null } {

        return {
            menuId:     this.route.snapshot.queryParamMap.get('menu_id'),
            menuItemId: this.route.snapshot.queryParamMap.get('menu_item_id')
        };

    }

}
